module.exports = __webpack_public_path__ + "img/tj.340c6f8.svg";